import React, { useEffect, useState } from 'react'
import Button1 from '../../../Button/Button1';
import ListOption from './ListOption';

import classes from "../CreateRule/SelectOutputs.module.css";
import Button2 from '../../../Button/Button2';

const SelectOutputs = ({ body, setBody, listItems, modalPageIndex, outputList, nextPage, isReminder, time }) => {

    console.log(listItems);
    let _listItems = listItems
    if (!isReminder) {
        _listItems = listItems.filter(item => item.type == "LATCH" || item.type == "VIRTUAL_LATCH")
    }
    //pass back selected outputs
    const [selectedOutputsInt, setSelectedOutputsInt] = useState([]);

    const HandeOnClick = () => {

        const tempArray = selectedOutputsInt

        const selectedOutputsAsString = tempArray;

        if (selectedOutputsAsString.length != 0) {
            setBody(prevBody => ({ ...prevBody, pin: selectedOutputsAsString }));
        }
        // isReminder == 1 ? nextPage(1) : nextPage(2);
        nextPage(1);
    }

    // item is always the exact object that was clicked, so there's no need to go look it back
    // up in listItems by pinName/Pin - that lookup could match the wrong item whenever pinName
    // wasn't unique across types, silently toggling a different pin than the one clicked and
    // leaving the clicked pin's own highlight/array entry out of sync.
    const isItemSelected = (item) => selectedOutputsInt.includes(String(item.Pin));

    const HandleOnItemClicked = (item) => {
        const pinAsString = String(item.Pin);

        setSelectedOutputsInt(prevSelectedOutputsInt =>
            prevSelectedOutputsInt.includes(pinAsString)
                ? prevSelectedOutputsInt.filter(pin => pin !== pinAsString)
                : [...prevSelectedOutputsInt, pinAsString]
        );
    }

    //filter out unwanted outputs
    const FilterArray = (listItems) => {
        // return listItems.filter(item => item.Pin != body.input);
        // return listItems.filter(item => item.pinName !== body.input && item.type !== "PULSE");

        return listItems
    }
    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "15px" }}>

            <div style={{ position: "absolute", right: "40px", top: "60px" }}>
                <button className={classes.nextButton} disabled={selectedOutputsInt.length == 0} onClick={HandeOnClick}>
                    {">"}
                </button>
            </div>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                <h3 style={{ color:"#6e6e6e"}}>{`Which switch do you want the ${isReminder == 0 ? "schedule" : "reminder"} on?`}</h3>
                <br></br>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                    <ul style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>

                            {FilterArray(_listItems).map((item, index) => {
                                const selected = isItemSelected(item);
                                return (
                                    <Button2 key={index} onClick={() => HandleOnItemClicked(item)} style={{ minWidth: "300px", minHeight:"40px", backgroundColor: selected && "var(--Primary-Color)", color: selected && "white", border: selected && "2px solid lightblue" }}>
                                        {item.pinName}
                                    </Button2>

                                )
                            })}
                        </ul >
                    
                </div>
            </div>

        </div >
    )
}

export default SelectOutputs